export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/watercolor_feminine.4f5d7e8.svg";